<template>
  <NuxtPage
    v-if="highlightData"
    :highlight="highlightData"
    :category="category"
    :data="data"
  />
  <!-- :collection="collection" -->
  <!-- @update:collection="onUpdateCollection" -->
</template>

<script setup>
const props = defineProps({
  category: {
    type: Object,
    default: () => ({}),
  },
});

const crumbsStore = useBreadcrumbsStore();
const route = useRoute();
const slug = route?.params?.category;
const { collectionSlug } = useCollectionSlug(slug);

const data = computed(() => {
  return itemBySlug?.data?.value;
});

const highlightData = computed(() => collectionSlug?.data?.value?.highlight);

const content = computed(() => {
  return route.query?.content ?? highlightData.value?.content_types?.[0]?.model;
});

const activeTile = computed(() => route.query.group || 'tile');

const { itemBySlug } = useCollectionItemBySlug(route.params?.category, content);

const parentChapter = computed(() => {
  if (!highlightData.value) return;
  return props.category?.chapters?.find((item) =>
    item.highlights?.find(
      (highlight) => highlight.slug === highlightData.value?.slug,
    ),
  );
});

// const collection = ref([]);

watch(
  parentChapter,
  (val) => {
    if (!val) return;
    crumbsStore.setCrumbs({
      key: 'chapter',
      value: {
        title: parentChapter.value?.number
          ? `Глава ${parentChapter.value?.number}. ${parentChapter.value?.title}`
          : parentChapter.value?.title,
        slug: `/teacher/${props.category?.slug}?category=${route.params.category}`,
      },
    });
  },
  { immediate: true },
);

watch(
  () => [content.value, props.category, highlightData.value, activeTile.value],
  ([content, category, highlightData, activeTile]) => {
    if (!content || !category || !highlightData || !activeTile) return;
    crumbsStore.setCrumbs({
      key: 'paragraph',
      value: {
        title: highlightData?.number
          ? `§ ${highlightData?.number}. ${highlightData?.title}`
          : highlightData?.title,
        slug: `/teacher/${category?.slug}/${
          highlightData?.slug
        }/?content=${content}${modernIsGroup(activeTile)}`,
        preamble: highlightData?.preamble,
      },
    });
  },
  { immediate: true },
);

onBeforeRouteLeave((to) => {
  if (!to.query.category) {
    crumbsStore.setCrumbs({ key: 'chapter', value: null });
  }
  crumbsStore.setCrumbs({ key: 'paragraph', value: null });
});

// const onUpdateCollection = (event) => {
//   collection.value = [...collection.value, ...event];
// };
</script>
